import { Command } from "commander";
import { CLI_VERSION } from "./constants.js";
import { resolveConfig, type GlobalOptions } from "./config.js";
import { registerAuthCommands } from "./commands/auth.js";
import { registerPluginCommands } from "./commands/plugin.js";
import { registerSkillCommands } from "./commands/skill.js";
import { AspError } from "./utils/errors.js";
import { printError } from "./utils/output.js";

const globalOpts: GlobalOptions = {};

const program = new Command()
  .name("asp")
  .description("AgentScope Platform CLI")
  .version(CLI_VERSION)
  .option("--platform-url <url>", "Custom Platform base URL (advanced)")
  .option("--token <token>", "Access token (overrides stored credentials)")
  .option("-v, --verbose", "Verbose logging")
  .option("--json", "Output JSON")
  .hook("preAction", (thisCommand) => {
    const opts = thisCommand.opts();
    globalOpts.platformUrl = opts.platformUrl;
    globalOpts.token = opts.token;
    globalOpts.verbose = opts.verbose;
    globalOpts.json = opts.json;
  });

const getConfig = () => resolveConfig(globalOpts);

registerAuthCommands(program, getConfig);
registerPluginCommands(program, getConfig);
registerSkillCommands(program, getConfig);

async function main(): Promise<void> {
  try {
    await program.parseAsync(process.argv);
  } catch (err) {
    if (err instanceof AspError) {
      printError(`${err.message} [${err.code}]`);
      if (err.hint) printError(`Hint: ${err.hint}`);
      if (err.requestId) printError(`Request ID: ${err.requestId}`);
      process.exit(err.exitCode);
    }
    if (err instanceof Error) {
      printError(err.message);
      if (globalOpts.verbose && err.stack) console.error(err.stack);
      process.exit(1);
    }
    throw err;
  }
}

main();
